module.exports = __webpack_public_path__ + "img/logo.ced72f63.png";